
const TRANSFER_IN_PROGRESS_MODAL = 'TRANSFER_IN_PROGRESS_MODAL';
const TRANSFER_SUCCESS_MODAL = 'TRANSFER_SUCCESS_MODAL';
const TRANSFER_PARTIAL_SUCCESS_MODAL = 'TRANSFER_PARTIAL_SUCCESS_MODAL';
const TRANSFER_FAILURE_MODAL = 'TRANSFER_FAILURE_MODAL';
const TRANSFER_INCOMPLETE_MODAL = 'TRANSFER_INCOMPLETE_MODAL';
const TRANSFER_ERROR_MODAL = 'TRANSFER_ERROR_MODAL';
const TRANSFER_VALIDATION_ERROR_MODAL = 'TRANSFER_VALIDATION_ERROR_MODAL';

const IN_PROGRESS = 'INPROGRESS';
const SUCCESS = 'SUCCESS';
const PARTIAL_SUCCESS = 'PARTIAL_SUCCESS';
const FAILED = 'FAILED';
const INCOMPLETE = 'INCOMPLETE';
const ERROR = 'ERROR';
const PENDING = 'PENDING';
const NONE = 'NONE';
const VALIDATION_ERROR = 'VALIDATION_ERROR';

export const entityModalTypes = {
    TRANSFER_IN_PROGRESS_MODAL,
    TRANSFER_SUCCESS_MODAL,
    TRANSFER_PARTIAL_SUCCESS_MODAL,
    TRANSFER_FAILURE_MODAL,
    TRANSFER_INCOMPLETE_MODAL,
    TRANSFER_ERROR_MODAL,
    TRANSFER_VALIDATION_ERROR_MODAL
};

export const transferStatusTypes = {
    IN_PROGRESS,
    SUCCESS,
    PARTIAL_SUCCESS,    
    INCOMPLETE,
    ERROR,
    FAILED,
    PENDING,
    NONE,
    VALIDATION_ERROR
};
